/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner';

/**
* Properties of the original AWS DynamoDB table at the time the snapshot was taken. Present only when `resourceType` is set to `AWS_DYNAMODB`. 
*/
export class AwsDynamoDbSnapshotProperties {
  /**
  * List of local secondary indexes on the table.
  */
  'localSecondaryIndexes'?: Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner>;
  /**
  * List of global secondary indexes on the table.
  */
  'globalSecondaryIndexes'?: Array<AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "localSecondaryIndexes",
      "baseName": "localSecondaryIndexes",
      "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner>",
      "format": ""
    },
    {
      "name": "globalSecondaryIndexes",
      "baseName": "globalSecondaryIndexes",
      "type": "Array<AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

